import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CoachingReviewTypeStore, {
  categories,
  typesAndCategories,
} from 'stores/coaching/CoachingReviewTypeStore';
import CoachingReviewTypePage from 'components/pure/admin/CoachingReviewTypePage';
import CoachingReviewTypeActions from 'actions/coaching/CoachingReviewTypeActions';
import {ensureReviewMetadata} from 'components/StatsPage2.utils';

@connectToStores
export default class CoachingReviewTypePageContainer extends React.PureComponent {
  static getStores() {
    return [CoachingReviewTypeStore];
  }

  static getPropsFromStores() {
    const [typesLoaded, types] = typesAndCategories(CoachingReviewTypeStore);
    const [categoriesLoaded, theCategories] = categories(CoachingReviewTypeStore);

    return {
      types: types.toList(),
      typesLoaded,
      categories: theCategories.toList(),
      categoriesLoaded,
    };
  }

  componentDidMount() {
    // force reload (and grab meeting types)
    CoachingReviewTypeActions.fetchAllReviewTypes(true).then(() => ensureReviewMetadata());
  }

  render() {
    return <CoachingReviewTypePage {...this.props} />;
  }
}
